import React from 'react';
import { useAppContext } from '../../../../Store/Store';

interface GeoRegisterScreenProps {
  onNext: () => void;
  showSkipNextScreenButton?: boolean;
  showBackButton?: boolean;
  onBack?: () => void;
}

const containerStyle = {
  margin: '0 auto',
  padding: '20px',
  width: '90%',
  maxWidth: '1100px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column' as const,
};

const GeoRegisterScreen: React.FC<GeoRegisterScreenProps> = ({
  onNext,
  showSkipNextScreenButton = false,
  showBackButton = false,
  onBack,
}) => {
  const { style } = useAppContext();

  const handleRegisterClick = () => {
    console.log('Register geo clicked');
    onNext();
  };

  const handleOtherClick = () => {
    if (style.geoAttributes.geo_second_button_url) {
      window.open(style.geoAttributes.geo_second_button_url, '_blank');
    } else {
      console.log('Other option clicked');
      onNext();
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        padding: '1rem',
        boxSizing: 'border-box',
        gap: 'clamp(16px, 3vh, 32px)',
      }}
    >
      {/* Main Register Button */}
      <button
        onClick={handleRegisterClick}
        style={{
          height: '4.6vh',
          minHeight: '44px',
          width: 'min(34vh, 90vw)',
          maxWidth: '420px',
          borderRadius: '7px',
          padding: '0 20px',
          fontSize: '90%',
          fontWeight: 'bold',
          color:
            style.geoAttributes.geo_register_button_text_color || '#07296A',
          background:
            style.geoAttributes.geo_register_button_bg_color ||
            'linear-gradient(to right, #6991F8 0%, #07296a 100%)',
          border: 'none',
          cursor: 'pointer',
          boxShadow:
            '0 5px 5px ' +
            (style.geoAttributes.geo_register_button_shadow_color || '#999'),
        }}
        dangerouslySetInnerHTML={{
          __html:
            style.geoAttributes.geo_register_button_indication ||
            'Registra la valvola',
        }}
      />

      {/* Second Button (optional) */}
      {style.geoAttributes.geo_show_second_button && (
        <button
          onClick={handleOtherClick}
          style={{
            height: '4.6vh',
            minHeight: '44px',
            width: 'min(34vh, 90vw)',
            maxWidth: '420px',
            borderRadius: '7px',
            padding: '0 20px',
            fontSize: '90%',
            fontWeight: 'bold',
            color:
              style.geoAttributes.geo_second_button_text_color || '#07296A',
            background:
              style.geoAttributes.geo_second_button_bg_color || '#e4e5e9',
            border: 'none',
            cursor: 'pointer',
            boxShadow:
              '0 5px 5px ' +
              (style.geoAttributes.geo_second_button_shadow_color || '#999'),
          }}
          dangerouslySetInnerHTML={{
            __html: style.geoAttributes.geo_second_button_indication || 'Altro',
          }}
        />
      )}
      {showBackButton && (
        <button
          type="button"
          onClick={() => onBack?.()}
          style={{
            fontSize: '18px',
            textDecoration: 'underline',
            color: style?.back_button_text_color || '#07296A',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: style?.back_button_indication || 'Back',
            }}
          />
        </button>
      )}
      {showSkipNextScreenButton && (
        <button
          type="button"
          onClick={onNext}
          style={{
            fontSize: '18px',
            textDecoration: 'underline',
            color: style?.skip_next_screen_button_text_color || '#07296A',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: style?.skip_next_screen_button_indication || 'Skip',
            }}
          />
        </button>
      )}
    </div>
  );
};

export default GeoRegisterScreen;
